import * as React from "react";
import { connect } from "react-redux";

import { formatDate } from "../../../../../utils/DateFormat";
import { PolicyRequest } from "../../../../../store/Policies/Types";
import { Products } from "../../../../../store/Product/Types";
import { isRemoteLoading, ReduxState } from "../../../../../store/ReduxState";
import { Pagination } from "@vwpfs/mary-air-lib/components/air/06-molecules/Pagination";
import { RowData, Table } from "@vwpfs/mary-air-lib/components/air/06-molecules/Table";
import { DispatchFunc } from "../../../../../store/ActionTypes";
import { ProductStatusTypeDisplay } from "../../../../../store/Product/Displays";
import { remoteTrigger } from "../../../../../store/RemoteActions";
import { RemoteScope } from "../../../../../store/RemoteTypes";
import { ThemePalette, ThemePaletteState } from "@vwpfs/mary-air-lib/theme/_Types";
import { TableSelectCell } from "../../../06-molecules/TableSelectCell";
import { Container } from "@vwpfs/mary-air-lib/components/air/03-base/Container";
import { Badge } from "@vwpfs/mary-air-lib/components/air/05-atoms/Badge";


interface State {
    selectedRows: string[];
}

/**
 *
 */
interface StateProps {
    policy: PolicyRequest;
    loading: boolean;
}

/**
 *
 */
interface OwnProps {
    results: Products;
    onChange: <K extends keyof PolicyRequest>(key: K, value: PolicyRequest[K]) => void;
    id?: string;
}

/**
 *
 */
interface DispatchProps {
    loadResults: (skip: number) => void;
}

/**
 *
 */
type Props = OwnProps & StateProps & DispatchProps;

/**
 *
 */
export const mapStateToProps = (s: ReduxState): StateProps => ({
    policy: s.prop("policyRequest").map(e => ({
        ...e,
    })),
    loading:
            isRemoteLoading(s, RemoteScope.PRODUCT_RESULTS)
    ,
});

/**
 *
 */
export const mapDispatchToProps = (dispatch: DispatchFunc): DispatchProps => ({
    loadResults: (skip: number) => dispatch(remoteTrigger(RemoteScope.PRODUCT_RESULTS, {
        skip: skip,
    })),
});

/**
 *
 */
export class ResultsComp
    extends React.Component<Props, State> {

    /**
     *
     * @param props
     */
    public constructor(props: Props) {
        super(props);
        this.state = this.refreshedRowState();
        this.selectItem = this.selectItem.bind(this);
        this.refreshedRowState = this.refreshedRowState.bind(this);
        this.handlePageClick = this.handlePageClick.bind(this);
        this.amIChecked = this.amIChecked.bind(this);
        this.getProcessedRows = this.getProcessedRows.bind(this);
        this.resultsData = this.resultsData.bind(this);
    }

    /**
     *
     */
    public render() {
        return (
            <React.Fragment>
                <Table
                    hasActions
                    data={{
                        columns: this.resultsData().columns,
                        rows: this.resultsData().rows,
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                        sort: this.resultsData().sort,
                    }}
                />
                {(this.props.results && this.props.results.totalPages && this.props.results.totalPages > 1) ?
                    <Container
                        className="scl-h-text-align--center"
                        theme={{
                            padding: { "": { t: 3, b: 2 }, "sm": { t: 4, b: 3 } },
                        }}
                    >
                        <Pagination
                            pageCount={this.props.results.totalPages}
                            currentPage={this.props.results.number}
                            onPageChange={this.handlePageClick}
                            theme={{ palette: ThemePalette.CONTRAST_PRIMARY }}
                        />
                    </Container> : null}
            </React.Fragment>
        );
    }

    private selectItem(value: boolean | undefined, id: string) {
        this.setState({
            selectedRows: !!value ? [
                id,
            ] : [],
        }, () => this.props.onChange("extendedWarranty", { id: Number(this.state.selectedRows[0]) }));
    }

    /**
     *
     */
    private refreshedRowState(): State {
        return {
            selectedRows: this.props.id ? [this.props.id] : [],
        };
    }

    private handlePageClick(skip: number) {
        this.props.loadResults(skip);
    }

    private amIChecked(id: string, selectedRows: string[]): boolean {
        return selectedRows.some((row) => row === id);
    }

    /**
     *
     */
    private getProcessedRows(): RowData[] {
        return this.props.results.content.map((row, index) => {
            const checked = this.amIChecked(row.id.toString(), this.state.selectedRows);
            return ({
                id: row.id,
                data: [
                    (
                        <TableSelectCell
                            key={`table-cell-${row.id}`}
                            checked={checked}
                            selectItem={() => this.selectItem(!checked, row.id.toString())}
                        />
                    ),
                    row.name ? row.name : "",
                    row.createdAt
                        ? formatDate(new Date(row.createdAt), "DD-MM-YYYY")
                        : "",
                    (
                        <Badge
                            theme={{ paletteState: ThemePaletteState.SUCCESS }}
                            key={`status-${index}`}
                        >
                            {ProductStatusTypeDisplay[row.status]}
                        </Badge>
                    ),
                ],
            });
        });
    }

    /**
     *
     */
    private resultsData() {
        return {
            sort: undefined,
            columns: [
                {
                    label: "Select",
                },
                {
                    label: "Name",
                },
                {
                    label: "Created at",
                },
                {
                    label: "Status",
                },
            ],
            rows: this.getProcessedRows(),
        };
    }
}

/**
 *
 */
export const Results = connect(
    mapStateToProps,
    mapDispatchToProps,
)(ResultsComp);
